import { render } from "./filter_fitness.svg?vue&type=template&id=c893c5f4?inline"
const script = {}
script.render = render

export default script